import React from 'react';
import { useSelector } from 'react-redux';
import { currentRotationAmountState } from '../../../../app/redux/retrievers/retrievers';
import './styles/compass.styles.css';

const Compass = () => {
    const currentRotationAmount = useSelector(currentRotationAmountState);
    return (
        <div
            className="compass"
            style={{ transformOrigin: 'center center', transform: `rotate(${(currentRotationAmount * 180) / Math.PI}deg)` }}
        >
            <img src="/images/icons/compass-red.png" alt="compass" style={{ height: 55, width: 55, opacity: 0.8 }} />
        </div>
    );
};

export default Compass;
